export function BackIcon({ className }: { className?: string }) {
  return (
    <svg
      width="18"
      height="8"
      viewBox="0 0 18 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.38867 0.666626C7.18034 0.666626 5.18034 1.49163 3.63867 2.83329L2.06367 1.25829C1.53867 0.733293 0.638672 1.09996 0.638672 1.84163V6.49996C0.638672 6.95829 1.01367 7.33329 1.47201 7.33329H6.13034C6.872 7.33329 7.247 6.43329 6.72201 5.90829L5.13034 4.31663C6.28867 3.34996 7.76367 2.74996 9.39701 2.74996C12.0303 2.74996 14.3053 4.28329 15.3887 6.49996C15.6137 6.96663 16.147 7.19996 16.6387 7.03329C17.2303 6.84163 17.5303 6.16663 17.2637 5.59996C15.8303 2.68329 12.847 0.666626 9.38867 0.666626Z"
        fill="currentColor"
      />
    </svg>
  )
}
